import React from 'react';
import { Form, Modal, Card, Table, Button } from 'react-bootstrap';
import { useState }  from 'react';
import FalconCloseButton from 'components/common/FalconCloseButton';
import  { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux';
import { updateContoEconomico } from '../reduxStore/questCorrenteSlice.js'

const formatNumber = (number) => {
  // const myNumber = Number(number)
  // return myNumber.toLocaleString('it-IT');

  // if (typeof number === 'number') {
  //   return number.toLocaleString('it-IT');
  // }

  return number;

};

/*
const getClassName = (number) => {
  return number >= 0 ? 'text-primary' : 'text-danger';
};
*/

const InputContoEconomico = () => {
// ----------------------------------------------------------
//  INIZIO GESTIONE Modal
  const [modalShow, setModalShow] = useState(false);

  const handleOpenModal = () => {
    setModalShow(true)
  }

  const handleCloseModal = () => {
    setModalShow(false)
  }
//  FINE GESTIONE Modal
// ----------------------------------------------------------

// ----------------------------------------------------------
  // estraggo array ambiti da questionarioCorrente:
  const questionarioCorrente = useSelector((state) => state.questCorrente);
  const ambitiArray = questionarioCorrente.ambiti

  console.log(ambitiArray)
// ----------------------------------------------------------


// ----------------------------------------------------------
//  INIZIO GESTIONE PER react-hook-form
const dispatch = useDispatch();
const { handleSubmit, register } = useForm({
  defaultValues: {
   // ambiti: ambitiArray.map(({ key, classe, descrizione, enabled }) => ({ key, classe, descrizione, enabled }))
  }
});

const onSubmit = (data) => {
  console.log('### ### Input conto economico - data: ', data);
  const updatedValues = {
    questionarioUuid: questionarioCorrente.questionarioUuid, 
    contoEconomico: data
}

  console.log('### ### Input conto economico - updatedValues: ', updatedValues)
  
  dispatch(updateContoEconomico(updatedValues)) 
  setModalShow(false)
};
//  FINE GESTIONE PER react-hook-form
// ----------------------------------------------------------


  const contoEconomico = useSelector(
    (state) => state.questCorrente.contoEconomico
  );

  return (<>
    <Card className="text-center">
      <Card.Body className="p-5">
        <Card.Title style={{marginBottom:"3%"}}>
          <h4 className="text-center">
            <strong>VALORE AGGIUNTO AZIENDALE</strong>
          </h4>
        </Card.Title>

        <Card.Text>
          <Table bordered responsive>
            <thead>
              <tr>
                <td className="text-primary"  align="left" colSpan="3">
                  <Button variant="primary" onClick={handleOpenModal}>
                    Aggiornamento valori conto economico
                  </Button>
                </td>
              </tr>
              <tr>
                <td className="text-primary"  align="center" colSpan="3">
                  <span style={{color:'red', fontSize:'100%'}}><strong>I valori che indicano un valore negativo devono essere inseriti con il segno meno</strong></span>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-primary"><strong>A</strong></td>
                <td className="text-primary" align="left"><strong>VALORE DELLA PRODUZIONE</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.A1 + contoEconomico.A2)}</strong></td>
              </tr>
              <tr>
                <td>A.1</td>
                <td align="left">Principali</td>
                <td align="right">{formatNumber(contoEconomico.A1)}</td>
              </tr>
              <tr>
                <td>A.2</td>
                <td align="left">Altri</td>
                <td align="right">{formatNumber(contoEconomico.A2)}</td>
              </tr>

              <tr>
                <td className="text-primary"><strong>B</strong></td>
                <td className="text-primary" align="left"><strong>COSTI INTERMEDI DELLA PRODUZIONE</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.B1 + contoEconomico.B2 + 
                  contoEconomico.B3 + contoEconomico.B4 + contoEconomico.B5 + contoEconomico.B6 + contoEconomico.B7 )}</strong></td>
              </tr>
              <tr>
                <td>B.1</td>
                <td align="left">Consumi materie prime</td>
                <td align="right">{formatNumber(contoEconomico.B1)}</td>
              </tr>
              <tr>
                <td>B.2</td>
                <td align="left">Consumi materie sussidarie</td>
                <td align="right">{formatNumber(contoEconomico.B2)}</td>
              </tr>
              <tr>
                <td>B.3</td>
                <td align="left">Costi per servizi</td>
                <td align="right">{formatNumber(contoEconomico.B3)}</td>
              </tr>
              <tr>
                <td>B.4</td>
                <td align="left">Costi godimento beni di terzi</td>
                <td align="right">{formatNumber(contoEconomico.B4)}</td>
              </tr>
              <tr>
                <td>B.5</td>
                <td align="left">Accantonamento rischi vari</td>
                <td align="right">{formatNumber(contoEconomico.B5)}</td>
              </tr>
              <tr>
                <td>B.6</td>
                <td align="left">Oneri diversi di gestione</td>
                <td align="right">{formatNumber(contoEconomico.B6)}</td>
              </tr>
              <tr>
                <td>B.7</td>
                <td align="left">Personale non dipendente</td>
                <td align="right">{formatNumber(contoEconomico.B7)}</td>
              </tr>


              <tr>
                <td className="text-primary"><strong>C</strong></td>
                <td className="text-primary" align="left"><strong>GESTIONE STRAORDINARIA</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.C1 + contoEconomico.C2 + contoEconomico.C3)}</strong></td>
              </tr>
              <tr>
                <td>C.1</td>
                <td align="left">Ricavi accessori</td>
                <td align="right">{formatNumber(contoEconomico.C1)}</td>
              </tr>
              <tr>
                <td>C.2</td>
                <td align="left">Costi/ricavi straordinari</td>
                <td align="right">{formatNumber(contoEconomico.C2)}</td>
              </tr>
              <tr>
                <td>C.3</td>
                <td align="left">Ammortamenti della gestione</td>
                <td align="right">{formatNumber(contoEconomico.C3)}</td>
              </tr>

              <tr>
                <td className="text-primary"><strong>E</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE PERSONALE</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.E1)}</strong></td>
              </tr>

              <tr>
                <td>E.1</td>
                <td align="left">Personale dipendente</td>
                <td align="right">{formatNumber(contoEconomico.E1)}</td>
              </tr>
 
              <tr>
                <td className="text-primary"><strong>F</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE PUBBLICA AMMIN.NE</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.F1)}</strong></td>
              </tr>

              <tr>
                <td>F.1</td>
                <td align="left">Remunerazione Pubblica Amministrazione</td>
                <td align="right">{formatNumber(contoEconomico.F1)}</td>
              </tr>
 
              <tr>
                <td className="text-primary"><strong>G</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE CAPITALE DI CREDITO</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.G1)}</strong></td>
              </tr>

              <tr>
                <td>G.1</td>
                <td align="left">Remunerazione capitale di credito</td>
                <td align="right">{(contoEconomico.G1)}</td>
             </tr>

              
              <tr>
                <td className="text-primary"><strong>H</strong></td>
                <td className="text-primary" align="left"><strong>LIBERALITÀ ESTERNE</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.H1)}</strong></td>
              </tr>
              <tr>
                <td>H.1</td>
                <td align="left">Liberalità esterne</td>
                <td align="right">{contoEconomico.H1}</td>
              </tr>

              <tr>
                <td className="text-primary"><strong>L</strong></td>
                <td className="text-primary" align="left"><strong>COSTI DIVERSI</strong></td>
                <td className="text-primary" align="right"><strong>{formatNumber(contoEconomico.L1)}</strong></td>
              </tr>
 
              <tr>
                <td>L.1</td>
                <td align="left">Costi diversi</td>
                <td align="right">{formatNumber(contoEconomico.L1)}</td>
              </tr>
 
            </tbody>
          </Table>

        </Card.Text>
      </Card.Body>
    </Card>

<hr />
<Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
  <Modal.Header>
    <Modal.Title>CONTO ECONOMICO</Modal.Title>
    <FalconCloseButton onClick={handleCloseModal}/>
  </Modal.Header>

  <Form onSubmit={handleSubmit(onSubmit)}>
    <Modal.Body>
    <span style={{color:'red', fontSize:'100%'}}><strong>ATTENZIONE: I valori che indicano un valore negativo devono essere inseriti con il segno meno</strong></span><br/><br/>
    <Table bordered responsive>
            <tbody>
              <tr>
                <td className="text-primary"><strong>A</strong></td>
                <td className="text-primary" align="left"><strong>VALORE DELLA PRODUZIONE</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>A.1</td>
                <td align="left">Principali</td>
                <td><input 
                      id="A1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.A1} 
                      className="no-arrows" 
                      style={{ width: '100%'}} 
                      {...register('A1')}
                                 
                  />
                </td>
              </tr>
              <tr>
                <td>A.2</td>
                <td align="left">Altri</td>
                <td><input 
                      id="A2" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.A2} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('A2')}
                  />
                </td>
              </tr>

              <tr>
                <td className="text-primary"><strong>B</strong></td>
                <td className="text-primary" align="left"><strong>COSTI INTERMEDI DELLA PRODUZIONE</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>B.1</td>
                <td align="left">Consumi materie prime</td>
                <td><input 
                      id="B1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B1')}
                  />
                </td>
              </tr>
              <tr>
                <td>B.2</td>
                <td align="left">Consumi materie sussidarie</td>
                <td><input 
                      id="B2" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B2} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B2')}
                  />
                </td>
              </tr>
              <tr>
                <td>B.3</td>
                <td align="left">Costi per servizi</td>
                <td><input 
                      id="B3" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B3} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B3')}
                  />
                </td>
              </tr>
              <tr>
                <td>B.4</td>
                <td align="left">Costi godimento beni di terzi</td>
                <td><input 
                      id="B4" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B4} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B4')}
                  />
                </td>
              </tr>
              <tr>
                <td>B.5</td>
                <td align="left">Accantonamento rischi vari</td>
                <td><input 
                      id="B5" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B5} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B5')}
                  />
                </td>
              </tr>
              <tr>
                <td>B.6</td>
                <td align="left">Oneri diversi di gestione</td>
                <td><input 
                      id="B6" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B6} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B6')}
                  />
                </td>
              </tr>
              <tr>
                <td>B.7</td>
                <td align="left">Personale non dipendente</td>
                <td><input 
                      id="B7" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.B7} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('B7')}
                  />
                </td>
              </tr>


              <tr>
                <td className="text-primary"><strong>C</strong></td>
                <td className="text-primary" align="left"><strong>GESTIONE STRAORDINARIA</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>C.1</td>
                <td align="left">Ricavi accessori</td>
                <td><input 
                      id="C1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.C1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('C1')}
                  />
                </td>
              </tr>
              <tr>
                <td>C.2</td>
                <td align="left">Costi/ricavi straordinari</td>
                <td><input 
                      id="C2" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.C2} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('C2')}
                  />
                </td>
              </tr>
              <tr>
                <td>C.3</td>
                <td align="left">Ammortamenti della gestione</td>
                <td><input 
                      id="C3" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.C3} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('C3')}
                  />
                </td>
              </tr>
              <tr>
                <td className="text-primary"><strong>E</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE PERSONALE</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>E.1</td>
                <td align="left">Personale dipendente</td>
                <td><input 
                      id="E1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.E1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('E1')}
                  />
                </td>
              </tr>
 
              <tr>
                <td className="text-primary"><strong>F</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE PUBBLICA AMMIN.NE</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>F.1</td>
                <td align="left">Remunerazione Pubblica Amministrazione</td>
                <td><input 
                      id="F1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.F1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('F1')}
                  />
                </td>
              </tr>
 
              <tr>
                <td className="text-primary"><strong>G</strong></td>
                <td className="text-primary" align="left"><strong>REMUNERAZIONE CAPITALE DI CREDITO</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>G.1</td>
                <td align="left">Remunerazione capitale di credito</td>
                <td><input 
                      id="G1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.G1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('G1')}
                  />
                </td>
             </tr>

              
              <tr>
                <td className="text-primary"><strong>H</strong></td>
                <td className="text-primary" align="left"><strong>LIBERALITÀ ESTERNE</strong></td>
                <td></td>
              </tr>
              <tr>
                <td>H.1</td>
                <td align="left">Liberalità esterne</td>
                <td><input 
                      id="H1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.H1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('H1')}
                  />
                </td>
              </tr>

              <tr>
                <td className="text-primary"><strong>L</strong></td>
                <td className="text-primary" align="left"><strong>COSTI DIVERSI</strong></td>
                <td></td>
              </tr>
 
              <tr>
                <td>L.1</td>
                <td align="left">Costi diversi</td>
                <td><input 
                      id="L1" 
                      type="number" 
                      autoComplete="off" 
                      defaultValue={contoEconomico.L1} 
                      className="no-arrows" 
                      style={{ width: '100%'}}                                  
                      {...register('L1')}
                  />
                </td>
              </tr>
 
            </tbody>
          </Table>

    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleCloseModal}>Annulla</Button>
      <Button variant="primary" type="submit" onSubmit={handleSubmit(onSubmit)}>Invia</Button>

    </Modal.Footer>
  </Form>
</Modal>
</>);
};

export default InputContoEconomico;
